export const fr = {
  integrationsPage: {
    meta: { title: 'Intégrations' },
    hero: {
      eyebrow: 'Intégrations',
      heading_main: 'Rejoignez votre équipe',
      heading_em: 'là où elle travaille déjà',
      lead: "Purposely s'intègre à Slack et Microsoft Teams, les invitations au bénévolat, les rappels et les inscriptions se font directement dans les canaux que votre équipe consulte chaque jour. Aucune nouvelle application à installer.",
    },
    availStrip: 'Les deux intégrations sont disponibles et prêtes à l\'emploi — en moins de deux minutes.',
    slack: {
      name: 'Slack',
      status: 'Disponible',
      headline: 'Des opportunités de bénévolat publiées dans les canaux où votre équipe travaille déjà',
      desc: "Connectez Purposely à votre espace de travail Slack et notre agent publiera des quarts de travail ciblés, enverra des rappels personnalisés et recueillera les confirmations de présence — sans que personne ne quitte Slack.",
      features: [
        "Publiez des événements dans n'importe quel canal — par équipe, lieu ou cause",
        'Mises à jour des événements envoyées automatiquement',
        'Rappels par message privé avant chaque quart',
      ],
      cta: 'Ajouter à Slack →',
      visual: {
        channel: '# mises-à-jour-bénévolat',
        meta: "12 membres · aujourd'hui",
        msgName: 'Purposely',
        msgTag: 'Application',
        msgTime: '10h42',
        msgText: "Bonjour l'équipe 👋 Nouveau quart correspondant à vos intérêts : <strong>Banque alimentaire de Vancouver — vendredi 14h</strong>. 8 places restantes.",
        btn1: '✓ Je participe',
        btn2: 'Peut-être',
        btn3: 'Voir les détails',
        reminderTitle: 'Rappel envoyé à 6 coéquipiers',
        reminderSub: 'Message automatique · 24h avant le quart',
      },
    },
    teams: {
      name: 'Microsoft Teams',
      status: 'Disponible',
      headline: 'Publications de canal et rappels — conçus nativement pour Teams',
      desc: "Intégrez Purposely à vos canaux Teams existants avec une prise en charge complète des Adaptive Cards. Le bot publie les événements correspondants, recueille les inscriptions et envoie des rappels personnalisés.",
      features: [
        "Connaissance des canaux : publiez dans une équipe ou toute l'organisation",
        'Rappels par chat personnel',
        'SSO Microsoft Entra (Azure AD) et contrôles administrateur',
      ],
      cta: 'Ajouter à Teams →',
      visual: {
        channel: 'Équipe RSE › Général',
        meta: 'Publié par Purposely · 9h14',
        cardTitle: '3 quarts disponibles cette semaine — correspondant à votre équipe',
        row1: { label: '🥫 Union Gospel — Préparation repas', val: 'Mer · 6 places' },
        row2: { label: '🌱 Nettoyage Stanley Park', val: 'Sam · 12 places' },
        row3: { label: '📚 Mentor lecture DLS', val: 'Ven · 4 places' },
        btn1: "✓ S'inscrire",
        btn2: 'Ajouter au calendrier',
      },
    },
    faq: {
      heading: 'Configuration et sécurité',
      items: [
        {
          q: "Combien de temps prend l'installation ?",
          a: "Moins de deux minutes. Un administrateur clique sur « Ajouter à Slack » ou « Ajouter à Teams », approuve les autorisations OAuth, choisit les canaux et c'est prêt.",
        },
        {
          q: 'Quelles autorisations Purposely demande-t-il ?',
          a: "Lire l'identité de l'utilisateur, publier dans les canaux autorisés et envoyer des messages privés aux utilisateurs consentants. Nous ne lisons jamais l'historique des messages hors de nos propres conversations, et nous ne publions jamais au nom d'un utilisateur.",
        },
        {
          q: 'Les employés peuvent-ils se désabonner des rappels ?',
          a: 'Oui — chaque message Purposely offre une option « désactiver les rappels » en un clic. Les administrateurs peuvent également définir des paramètres de cadence et d\'heures de silence à l\'échelle de l\'organisation.',
        },
      ],
    },
    cta: {
      heading_main: 'Prêt à automatiser',
      heading_em: 'le bénévolat ?',
      sub: 'Réservez une démo de 20 minutes et nous connecterons votre espace de travail en direct.',
      button: 'Réserver une démo →',
    },
  },
}
